// Mock data for Varni Visa website

export const tourPackages = [
  {
    id: 1,
    name: 'Kashmir Paradise',
    destination: 'Kashmir, India',
    duration: '6 Days / 5 Nights',
    price: '₹25,000',
    image: 'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxLYXNobWlyJTIwRGFsJTIwTGFrZXxlbnwwfHx8fDE3ODAyMzc0Mjd8MA&ixlib=rb-4.1.0&q=85',
    description: 'Experience the breathtaking beauty of Dal Lake, Gulmarg, and Pahalgam',
    featured: true
  },
  {
    id: 2,
    name: 'Bali Bliss',
    destination: 'Bali, Indonesia',
    duration: '7 Days / 6 Nights',
    price: '₹55,000',
    image: 'https://images.unsplash.com/photo-1604999333679-b86d54738315?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxCYWxpJTIwdGVtcGxlfGVufDB8fHx8MTc4MDIzNzQyN3ww&ixlib=rb-4.1.0&q=85',
    description: 'Explore ancient temples, pristine beaches, and lush rice terraces',
    featured: true
  },
  {
    id: 3,
    name: 'Dubai Deluxe',
    destination: 'Dubai, UAE',
    duration: '5 Days / 4 Nights',
    price: '₹45,000',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxEdWJhaSUyMHNreWxpbmV8ZW58MHx8fHwxNzgwMjM3NDI3fDA&ixlib=rb-4.1.0&q=85',
    description: 'Experience luxury shopping, desert safari, and iconic Burj Khalifa',
    featured: true
  },
  {
    id: 4,
    name: 'Thailand Tropical',
    destination: 'Thailand',
    duration: '6 Days / 5 Nights',
    price: '₹38,000',
    image: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxUaGFpbGFuZCUyMGJlYWNofGVufDB8fHx8MTc4MDIzNzQ2MHww&ixlib=rb-4.1.0&q=85',
    description: 'Discover Bangkok, Pattaya beaches, and vibrant Thai culture',
    featured: false
  },
  {
    id: 5,
    name: 'Vietnam Adventure',
    destination: 'Vietnam',
    duration: '7 Days / 6 Nights',
    price: '₹42,000',
    image: 'https://images.unsplash.com/photo-1528127269322-539801943592?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxWaWV0bmFtJTIwSGFsb25nJTIwQmF5fGVufDB8fHx8MTc4MDIzNzQ2MHww&ixlib=rb-4.1.0&q=85',
    description: 'Cruise through Halong Bay and explore Hanoi and Ho Chi Minh City',
    featured: false
  },
  {
    id: 6,
    name: 'Sikkim Serenity',
    destination: 'Sikkim, India',
    duration: '5 Days / 4 Nights',
    price: '₹22,000',
    image: 'https://images.unsplash.com/photo-1624725412168-a8e69d4f7b36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxTaWtraW0lMjBtb3VudGFpbnN8ZW58MHx8fHwxNzgwMjM3NDYwfDA&ixlib=rb-4.1.0&q=85',
    description: 'Explore Gangtok, Tsomgo Lake, and stunning Himalayan landscapes',
    featured: false
  }
];

export const visaServices = [
  {
    id: 1,
    country: 'Dubai',
    type: 'Tourist Visa',
    processingTime: '3-4 Days',
    price: '₹5,500',
    validity: '30/60 Days',
    icon: 'Plane',
    popular: true
  },
  {
    id: 2,
    country: 'Thailand',
    type: 'Tourist Visa',
    processingTime: '5-7 Days',
    price: '₹4,800',
    validity: '60 Days',
    icon: 'Palmtree',
    popular: true
  },
  {
    id: 3,
    country: 'Singapore',
    type: 'Tourist Visa',
    processingTime: '5-7 Days',
    price: '₹6,200',
    validity: '30 Days',
    icon: 'Building2',
    popular: true
  },
  {
    id: 4,
    country: 'Schengen',
    type: 'Tourist Visa',
    processingTime: '15-20 Days',
    price: '₹8,500',
    validity: '90 Days',
    icon: 'MapPin',
    popular: true
  },
  {
    id: 5,
    country: 'UK',
    type: 'Tourist Visa',
    processingTime: '15-20 Days',
    price: '₹12,000',
    validity: '180 Days',
    icon: 'Crown',
    popular: false
  },
  {
    id: 6,
    country: 'Canada',
    type: 'Tourist Visa',
    processingTime: '20-25 Days',
    price: '₹10,500',
    validity: '180 Days',
    icon: 'TreePine',
    popular: false
  },
  {
    id: 7,
    country: 'USA',
    type: 'Tourist Visa',
    processingTime: '30-45 Days',
    price: '₹15,000',
    validity: '10 Years',
    icon: 'Flag',
    popular: false
  },
  {
    id: 8,
    country: 'Australia',
    type: 'Tourist Visa',
    processingTime: '15-20 Days',
    price: '₹9,800',
    validity: '12 Months',
    icon: 'Globe',
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Patel',
    location: 'Surat, Gujarat',
    rating: 5,
    text: 'Excellent service! Got my Dubai visa in just 3 days. The team was very professional and helpful throughout the process.',
    date: '2024-01-15'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Mumbai, Maharashtra',
    rating: 5,
    text: 'Booked Thailand tour package and it was amazing! Everything was well organized from flights to hotels. Highly recommended!',
    date: '2024-01-10'
  },
  {
    id: 3,
    name: 'Amit Kumar',
    location: 'Ahmedabad, Gujarat',
    rating: 5,
    text: 'Best travel agency in Surat! Got great deals on flight booking and their visa guidance was exceptional. Thank you Varni Visa!',
    date: '2024-01-05'
  },
  {
    id: 4,
    name: 'Sneha Desai',
    location: 'Vadodara, Gujarat',
    rating: 5,
    text: 'Wonderful experience booking our Bali honeymoon package. The team took care of everything. Truly a trusted travel partner!',
    date: '2023-12-28'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Top 10 Things to Do in Dubai',
    excerpt: 'Discover the best attractions and experiences in Dubai, from Burj Khalifa to desert safari adventures.',
    image: 'https://images.pexels.com/photos/18341554/pexels-photo-18341554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    author: 'Varni Visa Team',
    date: '2024-01-20',
    category: 'Travel Guide'
  },
  {
    id: 2,
    title: 'Complete Guide to Schengen Visa',
    excerpt: 'Everything you need to know about applying for a Schengen visa - requirements, process, and tips.',
    image: 'https://images.unsplash.com/photo-1553697388-94e804e2f0f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHx2aXNhJTIwcGFzc3BvcnR8ZW58MHx8fHwxNzgwMjM3NDg2fDA&ixlib=rb-4.1.0&q=85',
    author: 'Varni Visa Team',
    date: '2024-01-18',
    category: 'Visa Guide'
  },
  {
    id: 3,
    title: 'Best Time to Visit Kashmir',
    excerpt: 'Plan your Kashmir trip with our seasonal guide covering weather, activities, and travel tips.',
    image: 'https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxLYXNobWlyJTIwRGFsJTIwTGFrZXxlbnwwfHx8fDE3ODAyMzc0Mjd8MA&ixlib=rb-4.1.0&q=85',
    author: 'Varni Visa Team',
    date: '2024-01-15',
    category: 'Travel Guide'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Expert Visa Guidance',
    description: 'Professional assistance for all types of visa applications with high success rate',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Fast Processing',
    description: 'Quick and efficient visa processing with regular status updates',
    icon: 'Zap'
  },
  {
    id: 3,
    title: 'Best Travel Deals',
    description: 'Competitive pricing on tour packages, flights, and hotel bookings',
    icon: 'Tag'
  },
  {
    id: 4,
    title: 'Dedicated Support',
    description: '24/7 customer support for all your travel and visa queries',
    icon: 'HeadphonesIcon'
  },
  {
    id: 5,
    title: 'Trusted Partner',
    description: 'Years of experience serving thousands of satisfied customers',
    icon: 'Award'
  },
  {
    id: 6,
    title: 'Complete Solutions',
    description: 'One-stop solution for visa, tours, flights, and accommodations',
    icon: 'CheckCircle'
  }
];

export const services = [
  {
    id: 1,
    title: 'Visa Assistance',
    description: 'Professional visa consulting and documentation for all countries',
    icon: 'FileText',
    link: '/visa-services'
  },
  {
    id: 2,
    title: 'International Tours',
    description: 'Curated tour packages to popular destinations worldwide',
    icon: 'Globe',
    link: '/tour-packages'
  },
  {
    id: 3,
    title: 'Flight Booking',
    description: 'Best deals on domestic and international flight tickets',
    icon: 'Plane',
    link: '/flights'
  },
  {
    id: 4,
    title: 'Hotel Booking',
    description: 'Wide range of accommodation options at competitive prices',
    icon: 'Hotel',
    link: '/hotels'
  },
  {
    id: 5,
    title: 'Thailand DMC',
    description: 'Direct ground handling via Varni2Fly Pattaya — hotels, transfers, tours',
    icon: 'Globe',
    link: '/thailand-dmc'
  },
  {
    id: 6,
    title: 'Group Tours',
    description: 'Custom group packages for families, friends, schools and clubs',
    icon: 'Users',
    link: '/contact'
  },
  {
    id: 7,
    title: 'Customized Holidays',
    description: 'Tailor-made itineraries built around your dates, budget and interests',
    icon: 'Sparkles',
    link: '/contact'
  },
  {
    id: 8,
    title: 'Airport Transfers',
    description: 'Reliable pickups and drops in India and Thailand operations',
    icon: 'Plane',
    link: '/thailand-dmc'
  },
  {
    id: 9,
    title: 'Corporate Travel',
    description: 'MICE, incentives, conferences and corporate retreats end-to-end',
    icon: 'Briefcase',
    link: '/thailand-dmc'
  }
];

export const contactInfo = {
  phones: ['+91 90169 30091', '+91 73888 13555'],
  emails: ['info@varnivisa.com', 'varnivisa@gmail.com'],
  website: 'www.varnivisa.com',
  address: '105 Anupam Business Hub, Yogi Chowk, Surat, Gujarat, India',
  whatsapp: '+919016930091'
};